import { Show } from "solid-js"
import { createStore } from "solid-js/store"
import { useLanguage } from "@/context/language"
import { TablerIcon } from "./tabler-icons"

// A record's id behind a copy icon (DESIGN-LOG §47: no raw ids in the Technical details sheet). The id is the tooltip;
// a click copies it and says so for two seconds.
export function CopyID(props: { id: string }) {
  const language = useLanguage()
  const [state, setState] = createStore({ copied: false })
  let timer: ReturnType<typeof setTimeout> | undefined
  const copy = (event: MouseEvent) => {
    event.stopPropagation()
    void navigator.clipboard?.writeText(props.id).then(() => {
      setState("copied", true)
      clearTimeout(timer)
      timer = setTimeout(() => setState("copied", false), 2000)
    }).catch(() => undefined)
  }
  return (
    <Show when={props.id}>
      <button type="button" class="dx-copy-id" title={`${language.t("datox.v2.tech.copyID")}: ${props.id}`} aria-label={language.t("datox.v2.tech.copyID")} onClick={copy}>
        <TablerIcon name={state.copied ? "check" : "copy"} size={12} stroke-width="1.5" />
        <span class="sr-only" role="status">{state.copied ? language.t("datox.v2.tech.copiedID") : ""}</span>
      </button>
    </Show>
  )
}
